import { useCallback, useMemo } from 'react';
import { useTheme } from '@material-ui/core/styles';
import { useSidebarPinState } from '@backstage/core-components';
import { rules } from './rules/rules.esm.js';

const useSidebar = () => useSidebarPinState();
const useRuleStyles = () => {
  const sidebar = useSidebar();
  const theme = useTheme();
  return useMemo(() => {
    const options = { theme, sidebar };
    return rules.reduce((styles, rule) => styles + rule(options), "");
  }, [theme, sidebar]);
};
const useStylesTransformer = () => {
  const styles = useRuleStyles();
  return useCallback(
    (dom) => {
      dom.getElementsByTagName("head")[0].insertAdjacentHTML("beforeend", `<style>${styles}</style>`);
      return dom;
    },
    [styles]
  );
};

export { useStylesTransformer };
//# sourceMappingURL=transformer.esm.js.map
